export default __webpack_public_path__ + "images/change-view.1c195b9a71a4e05d18e6a00f626ab30c.svg";